<template>
  <div class="media-form">
    <div class="title">媒体信息</div>
    <div class="form">
      <van-form ref="mediaForm" input-align="right" error-message-align="right">
        <van-cell-group>
          <!-- 社交媒体使用程度 -->
          <van-field
            v-model="formData.usageLevel"
            label="社交媒体"
            placeholder="请选择社交媒体使用程度"
            readonly
            is-link
            :rules="[{ required: true, message: '请选择社交媒体使用程度' }]"
            @click="showUsageLevelPicker = true"
          />
          <div v-if="formData.usageLevel && formData.usageLevel !=='不使用社交媒体'">
          <!-- 是否愿意分享 -->
          <van-field
            v-model="formData.willingToShare"
            label="是否愿意分享"
            placeholder="请选择是否愿意分享"
            readonly
            is-link
            :rules="[{ required: true, message: '请选择是否愿意分享' }]"
            @click="showWillingToSharePicker = true"
          />
          
          <!-- 粉丝数量 -->
          <van-field
            v-model="formData.fansCount"
            label="粉丝数量"
            placeholder="请选择粉丝数量范围"
            readonly
            is-link
            :rules="[{ required: true, message: '请选择粉丝数量范围' }]"
            @click="showFansCountPicker = true"
          />
          
          <!-- 使用社交平台数量 -->
          <van-field
            v-model="formData.platformCount"
            label="使用平台"
            placeholder="请选择使用社交平台数量"
            readonly
            is-link
            :rules="[{ required: true, message: '请选择使用社交平台数量' }]"
            @click="showPlatformCountPicker = true"
          />
          
          <div class="self-introduction">
            <div class="title2">社媒账号</div>
            <div class="content">
            <van-field 
                input-align="left"
                rows="2"
                autosize
                show-word-limit
                v-model="formData.acountLinks" 
                placeholder="请输入社交媒体账号链接，多个链接请换行输入"
                type="textarea"
            /> 
            </div>
        </div>
          </div>
        </van-cell-group>
      </van-form>
    </div>

    <!-- 社交媒体使用程度选择器 -->
    <van-popup v-model="showUsageLevelPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="usageLevelOptions"
        @confirm="onUsageLevelConfirm"
        @cancel="showUsageLevelPicker = false"
      />
    </van-popup>

    <!-- 是否愿意分享选择器 -->
    <van-popup v-model="showWillingToSharePicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="willingToShareOptions"
        @confirm="onWillingToShareConfirm"
        @cancel="showWillingToSharePicker = false"
      />
    </van-popup>

    <!-- 粉丝数量选择器 -->
    <van-popup v-model="showFansCountPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="fansCountOptions"
        @confirm="onFansCountConfirm"
        @cancel="showFansCountPicker = false"
      />
    </van-popup>

    <!-- 使用社交平台数量选择器 -->
    <van-popup v-model="showPlatformCountPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="platformCountOptions"
        @confirm="onPlatformCountConfirm"
        @cancel="showPlatformCountPicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue'
import { Form, Field, Icon, Popup, Picker, CellGroup, Toast} from "vant";
Vue.use(Form).use(Field).use(Icon).use(Popup).use(Picker).use(CellGroup).use(Toast)

export default {
  props: {
    form: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      formData: {
        usageLevel: '',
        willingToShare: '',
        fansCount: '',
        platformCount: '',
        acountLinks: ''
      },
      // 选择器显示状态
      showUsageLevelPicker: false,
      showWillingToSharePicker: false,
      showFansCountPicker: false,
      showPlatformCountPicker: false,
      
      // 选项数据
      usageLevelOptions: ['社媒深度用户(经常发布社交内容和互动)', '浏览内容并愿意进行互动(点赞、收藏、评论等)', '只浏览内容，不愿意互动或发布内容'],
      willingToShareOptions: ['是', '否'],
      fansCountOptions: ['5000以上', '4000以上', '2000以上', '1000以上', '500以上'],
      platformCountOptions: ['6个以上', '5个以上', '4个以上']
    };
  },
  watch: {
    form: {
      handler(newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          // 避免循环更新，只在数据真正不同时才更新
          if (JSON.stringify(this.formData) !== JSON.stringify(newVal)) {
            this.formData = JSON.parse(JSON.stringify(newVal));
          }
        }
      },
      immediate: true,
      deep: true
    },
    'formData.acountLinks': {
      handler() {
       this.$emit('update:form', { ...this.formData });
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    // 社交媒体使用程度确认
    onUsageLevelConfirm(value) {
      this.formData.usageLevel = value;
      this.showUsageLevelPicker = false;
      this.$emit('update:form', { ...this.formData });
    },
    
    // 是否愿意分享确认
    onWillingToShareConfirm(value) {
      this.formData.willingToShare = value;
      this.showWillingToSharePicker = false;
      this.$emit('update:form', { ...this.formData });
    },
    
    // 粉丝数量确认
    onFansCountConfirm(value) {
      this.formData.fansCount = value;
      this.showFansCountPicker = false;
      this.$emit('update:form', { ...this.formData });
    },
    
    // 使用社交平台数量确认
    onPlatformCountConfirm(value) {
      this.formData.platformCount = value;
      this.showPlatformCountPicker = false;
      this.$emit('update:form', { ...this.formData });
    },
    
    // 验证表单
    validateForm() {
      return this.$refs.mediaForm.validate()
    },
    
    // 重置表单
    resetForm() {
      this.formData = {
        usageLevel: '',
        willingToShare: '',
        fansCount: '',
        platformCount: '',
        acountLinks: ''
      };
    }
  }
};
</script>

<style scoped lang="scss">
.media-form{
  .title{
    background-color: #F5F5F5;
    font-size: 16px;
    font-weight: 600;
    color: #323233;
    height: 40px;
    line-height: 40px;
    padding: 0 15px;
  }
}
.self-introduction{
  .title2{
    color: rgba(0, 0, 0, 0.9);
    font-size: 14px;
    height: 40px;
    line-height: 40px;
    padding: 0 15px;
    box-sizing: border-box;
  }
}

::v-deep .van-cell{
  min-height: 54px;
  box-sizing: border-box;
  align-items: center;
}

::v-deep .van-field__label{
  color: rgba(0, 0, 0, 0.9);
}

::v-deep .van-field__control{
  font-weight: 500;
}

// 多行文本输入框样式
::v-deep .van-field__control--textarea {
  min-height: 60px;
  padding: 8px 0;
}

::v-deep .van-field__control--textarea textarea {
  font-size: 14px;
  line-height: 1.5;
  color: #323233;
}

::v-deep .van-field__control--textarea textarea::placeholder {
  color: #969799;
  font-size: 14px;
}
</style>
